import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import React, { Dispatch, SetStateAction, useRef, useState } from "react";
import { DropdownRules } from "../../types/field";
import { InputComponent } from "../../components/input/inputuncontrolled";
import { MinusCircleOutlined } from "@ant-design/icons";
import { DenominationOptionValues } from "../../types/types";

type Props = {
  optionList: Array<any>;
  title?: string;
  placeholder?: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  dropdownCode?: string;
  dropdownValue?: string;
  enableSearch?: boolean;
  mode?: any;
  allowClear?: boolean;
  loading?: boolean;
  rules?: DropdownRules;
  control: any;
  name: string;
  setValue?: any;
  resetValue?: any;
  getValues?: any;
  selectedOptions: DenominationOptionValues[];
  panelInfo?: any;
  setSelectedDenominationOptions: Dispatch<SetStateAction<DenominationOptionValues[]>>;
};


const { Option } = Select;

const Denomination: React.FC<Props> = ({
  title,
  loading,
  data,
  onChange,
  placeholder,
  disabled,
  dropdownCode,
  dropdownValue,
  allowClear,
  mode,
  rules,
  control,
  name,
  setValue,
  resetValue,
  selectedOptions,
  optionList,
  setSelectedDenominationOptions,
  panelInfo
}) => {

  const totalAmount = useRef<number>(0);

  const handleRowDelete = (denominationNumber: number, denominationTimes: number) => {

    setSelectedDenominationOptions(options => {
      const updatedData = options.filter((x) => x.value !== denominationNumber);
      return updatedData;
    });
    
    let total = totalAmount.current - (denominationNumber * denominationTimes);

    totalAmount.current = total;
    let field = "";
    if (name === "receivedDenom") {
      field = "totalReceivedAmount";
    }

    if (name === "returnedDenom") {
      field = "totalReturnedAmount";
    }
    setValue(field, total);
  };

  const handleAmountIncrement = (value: number, times: number) => {

    const updatedData = selectedOptions.map((x) => {
      if (x.value === value) {
        return { value, times };
      }
      return x;
    });

    setSelectedDenominationOptions(updatedData);

    let sum = 0;
    updatedData.forEach((item) => {
      if(item.times && item.times > 0) {
        sum = sum + (item.value*item.times);
      }
    })

    totalAmount.current = sum;
    let field = "";

    if (name === "receivedDenom") {
      field = "totalReceivedAmount";
    }

    if (name === "returnedDenom") {
      field = "totalReturnedAmount";
    }

    setValue(field, totalAmount.current);


  };


  let dropDownMode = rules?.isMulti ? "multiple" : mode;
  return (
    <div>

      <div className="d-flex justify-content-between my-2 align-items-center">
        <div className="subHeading text-base my-2 mx-2 font-semibold">
          {title}
        </div>
        <div>
          {panelInfo}
        </div>
      </div>
      <div>
        <Form.Item>

          <Row gutter={16}>
            <Col xs={24} lg={10}>
              <Select
                mode={dropDownMode}
                placeholder={placeholder}
                disabled={disabled}
                loading={loading}
                showSearch
                allowClear={allowClear}
                onChange={(value) => {
                  let v = selectedOptions.find((x) => x.value === value);
                  if (v) {
                    return;
                  }
                  let options = [...selectedOptions, { value, times: 0 }];
                  setSelectedDenominationOptions(options);
                }}
              >
                {optionList.map((item: any, idx: number) => (
                  <Option
                    key={idx}
                    value={item?.[dropdownCode ? dropdownCode : "name"]}
                  >
                    {`${item?.[dropdownValue ? dropdownValue : "name"]}`}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
        </Form.Item>

        {selectedOptions.map((item: DenominationOptionValues, index: number) => (
          <DenominationRow
            control={control}
            denominationNumber={item.value}
            denominationTimes={item.times ?? 0}
            name={`${name}`}
            data={data}
            onDeleteRow={handleRowDelete}
            setValue={setValue}
            resetValue={resetValue}
            handleAmountIncrement={handleAmountIncrement}
          />
        ))}
      </div>

    </div>
  );
};

type DenominationRowProps = {
  title?: string;
  placeholder?: string;
  onChange?: any;
  disabled?: boolean;
  data?: any;
  className?: string;
  dropdownCode?: string;
  dropdownValue?: string;
  enableSearch?: boolean;
  mode?: any;
  allowClear?: boolean;
  loading?: boolean;
  rules?: DropdownRules;
  control: any;
  name: string;
  setValue?: any;
  onDeleteRow?: any;
  resetValue?: any;
  denominationNumber: number;
  denominationTimes: number;
  handleAmountIncrement?: any;
};

const DenominationRow: React.FC<DenominationRowProps> = ({
  title,
  denominationNumber,
  denominationTimes,
  placeholder,
  control,
  name,
  setValue,
  onDeleteRow,
  resetValue,
  handleAmountIncrement,
}) => {
  const denomName = `${name}${denominationNumber}`;
  const denomAmountName = `${name}${denominationNumber}Amount`;
  return (
    <Row gutter={16}>
      <Col span={10}>
        <Form.Item>
          <Input disabled={true} value={denominationNumber} readOnly={true} />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item>
          <InputNumber
            title=""
            placeholder=""
            name={denomName}
            value={denominationTimes}
            min={0}
            max={500}
            defaultValue={0}
            onChange={(num: any) => {
              handleAmountIncrement(denominationNumber, num);
            }}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item>
          <InputComponent
            control={control}
            name={denomAmountName}
            title={title!}
            setValue={setValue}
            placeholder={placeholder!}
            disabled={true}
            data={denominationNumber * denominationTimes}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item>
          <MinusCircleOutlined
            onClick={() => {
              onDeleteRow(denominationNumber, denominationTimes);
              resetValue(denomAmountName, 0);
              resetValue(denomName, 0);
            }} rev={undefined} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default Denomination;
